package one.healthium.health_tools.di

import one.healthium.health_tools.ui.HealthToolsViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val healthToolsModule = module {
    viewModelOf(::HealthToolsViewModel)
}